module.exports = __webpack_public_path__ + "img/babycare.f7b4bf46.png";